export const memberPostNotificationSettingsFields = () => `
  __typename
  enabled
  memberId
  postId
`
